import React from 'react';
import './FilterPanel.scss';

export const FilterPanelLoading = () => (
    <aside className="filter-panel-desktop-container filter-panel-loading"></aside>
);
